/**
 * 通过crypto-js实现加解密
 * AES
 */
import CryptoJS from 'crypto-js';
const cnoocAes = {
  key: '!QA2Z@w1sxO*(-8L', // 秘钥 16*n
  iv: '!WFNZFU_{H%M(S|a' // 偏移量
};

function getAesString(data, key, iv) {
  // 加密
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString(); // 返回的是base64格式的密文
}

function getDAesString(encrypted, key, iv) {
  // 解密
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
// AES 对称秘钥加密
const aes = {
  encrypt: (data, key) => getAesString(data, key || cnoocAes.key, cnoocAes.iv),
  decrypt: (data, key) => getDAesString(data, key || cnoocAes.key, cnoocAes.iv)
};

export { aes };
